// Module
var code = "<span title=\"{{ $parent.row['segment-portion'] | number : 3 }}% of {{ $parent.row.phrase }} consumption is by selected audience\"\n      am-tooltip=\"top center to bottom center\"\n      am-tooltip-type=\"info\">\n    {{$parent.row['segment-portion'] | number : 3}}%\n</span>\n";
// Exports
module.exports = code;